import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12.602 5.898 3.5 3.5a.843.843 0 0 1 0 1.23.843.843 0 0 1-1.23 0l-1.997-1.995V13.5c0 .492-.41.875-.875.875a.864.864 0 0 1-.875-.875V8.633l-2.023 1.996a.843.843 0 0 1-1.23 0 .843.843 0 0 1 0-1.23l3.5-3.5a.843.843 0 0 1 1.23 0M7.625 16.125h8.75a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875h-8.75A.864.864 0 0 1 6.75 17c0-.465.383-.875.875-.875"
    }, null, -1)
  ]))]))
}
export default { render: render }